<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 商品中心->公共套餐 -->
    <div class="main2" style="margin:-20px 0 0 250px;">
      <div v-if="!goodsShow" class="main2">
        <div
          class="top"
          style="text-align:right;padding-bottom:20px;position:relative;z-index:999;"
        >
          <el-button
            size="small"
            style="padding:10px 20px;border-color:#97c5e9;background:#efefef;margin:0;border-radius:0;font-size:18px;"
            @click="addSetmeal"
            >新建{{ obj.name }}</el-button
          >
          <el-button
            size="small"
            style="padding:10px 20px;border-color:#97c5e9;background:#efefef;margin:0 0 0 -1px;border-radius:0;font-size:18px;"
            @click="getBefore2"
            >导出选中</el-button
          >
          <el-button
            size="small"
            style="padding:10px 20px;border-color:#97c5e9;background:#efefef;margin:0 0 0 -1px;border-radius:0;font-size:18px;"
            @click="getBefore"
            >导出全部</el-button
          >
        </div>
        <div class="bottom">
          <el-table
            ref="tableF"
            :data="aryList"
            style="width: 100%;border-left:2px solid #cacecf"
            :cell-style="{
              'border-right': '2px solid #cacecf',
              'border-bottom': '2px solid #cacecf',
            }"
            :header-cell-style="{
              'background-color': '#b6b6b6',
              color: '#fff',
              fontSize: '16px',
              fontWeight: '300',
              'text-align': 'center',
            }"
            @selection-change="SelectionChange"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column
              prop="setmealName"
              label="产品组合名称"
              align="center"
              width="180"
            >
              <template slot-scope="scope">
                {{ scope.row.setmealName }}
              </template>
            </el-table-column>
            <el-table-column prop="setmealCode" label="SKU" width="160">
            </el-table-column>
            <el-table-column prop="goodList" label="包含产品">
              <template slot-scope="scope">
                <div v-html="getGoodList(scope.row)"></div>
              </template>
            </el-table-column>
            <el-table-column prop="marketPrice" label="价格" width="110">
              <template slot-scope="scope">
                {{ to_f(scope.row.marketPrice || "0.00") }}
              </template>
            </el-table-column>
            <el-table-column label="操作" width="240">
              <template slot-scope="scope">
                <div>
                  <el-button
                    size="small"
                    style="border-color:#97c5e9;font-size:16px;"
                    @click="handleEdit(scope.$index, scope.row)"
                    >修改</el-button
                  >
                  <el-button
                    size="small"
                    style="border-color:#97c5e9;font-size:16px;"
                    @click="handleDelete(scope.$index, scope.row)"
                    >删除</el-button
                  >
                </div>
                <div style="margin-top:5px;">
                  <el-button
                    size="small"
                    style="border-color:#97c5e9;font-size:16px;"
                    @click="handleGoods(scope.$index, scope.row)"
                    >管理产品</el-button
                  >
                  <el-input-number
                    v-model="scope.row.amount"
                    :min="1"
                    size="mini"
                    step-strictly
                    style="width:100px;margin-left:5px;"
                  ></el-input-number>
                  &nbsp;&nbsp;
                  <el-button
                    size="small"
                    style="border-color:#97c5e9;font-size:16px;margin-top:5px;"
                    @click="addCart(scope.$index, scope.row)"
                    >加入购物车</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <br />
        <br />
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
        <el-button size="mini" style="display:inline-block;">GO</el-button>
      </div>
      <div v-if="goodsShow" class="main2" style="margin-top:70px;">
        <setmeal-goods-set
          :row="selectRow"
          ref="goodsSet"
          @fetch-data="getList"
        />
      </div>
    </div>
    <!-- 商品中心->公共套餐 -->
    <el-dialog :title="editTitle" :visible.sync="editShow">
      <el-form ref="form" :model="form" :rules="rules" label-position="top">
        <el-form-item
          label="组合名称"
          prop="setmealName"
          :label-width="formLabelWidth"
        >
          <el-input v-model="form.setmealName" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align:left;" class="dialog-footer">
        <el-button @click="saveEdit">保 存</el-button>
        <!--<el-button @click="closeEditShow">取 消</el-button>-->
      </div>
    </el-dialog>
    <setmeal-goods ref="edit" @fetch-data="getList" />
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import setmealGoods from "../components/setmealGoods";
import setmealGoodsSet from "../components/setmealGoodsSet";
import {
  getUrl,
  exportSetmealReequest,
  setmealListRequest,
  addSetmealRequest,
  editSetmealRequest,
  delSetmealRequest,
  addCartRequest,
} from "../../../public/js/service";

export default {
  props: ["obj"],
  data() {
    // 1.data
    return {
      totalPages: 1, // 1.1.总页码,
      pageNum: 1, // 1.2.当前页码
      total: 1, // 1.3.总条数
      pageSize: 10, // 1.4.每页条数
      aryList: [], // 1.5.套餐列表数据
      token: "", // 1.6.token
      formLabelWidth: "120px",
      editShow: false,
      editTitle: "添加组合",
      goodsShow: false,
      form: {},
      rules: {
        setmealName: [
          { required: true, message: "请输组合名称", trigger: "blur" },
        ],
      },
      selectRow: {},
    };
  },

  components: {
    setmealGoods,
    setmealGoodsSet,
  },

  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getList();
    },

    getList() {
      // 3.4.获取套餐列表信息
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        setmealType: this.obj.id,
      };
      this.goodsShow = false;
      setmealListRequest(data).then((res) => {
        this.aryList = res.data.map((item) => {
          item.amount = 1;
          let jj = 0;
          if (item.setmealGoodsList) {
            let price = 0.0;
            for (let j = 0; j < item.setmealGoodsList.length; j++) {
              let row = item.setmealGoodsList[j];
              let qq = parseInt(row["amount"] || "1");
              let pp = parseFloat(row["shopPrice"] || "99999.00");
              price += qq * pp;
              jj += qq;
            }
            item.marketPrice = price;
          }
          item.goodCount = jj;
          return item;
        });

        this.total = res.totals || 1;
        this.totalPages = Math.ceil(res.totals / this.pageSize) || 1;
      });
    },
    getGoodList(row) {
      let rr = "";
      if (row.setmealGoodsList) {
        for (let j = 0; j < row.setmealGoodsList.length; j++) {
          let vv = row.setmealGoodsList[j];
          rr += "<div>" + vv.goodsName + "(" + vv.amount + ")" + "</div>";
        }
      }
      return rr;
    },
    addSetmeal() {
      this.editTitle = "添加" + this.obj.name;
      this.editShow = true;
      this.form = {
        setmealId: null,
        setmealName: null,
        setmealCode: null,
        setmealType: this.obj.id,
      };
      if (this.$refs["form"]) {
        this.$refs["form"].resetFields();
      }
    },
    handleEdit(index, row) {
      console.log(index);
      if (this.$refs["form"]) {
        this.$refs["form"].resetFields();
      }
      this.editTitle = "修改" + this.obj.name;
      this.editShow = true;
      this.form = {
        setmealId: row.setmealId,
        setmealName: row.setmealName,
        setmealType: this.obj.id,
      };
    },
    handleGoods(index, row) {
      console.log(row);
      //this.$refs["edit"].showEdit(row);
      this.selectRow = row;
      this.goodsShow = true;
    },
    addCart(index, row) {
      let data = {
        index: index,
        setmealId: row.setmealId,
        amount: row.amount,
      };
      if (row.goodCount > 0) {
        addCartRequest(data).then((res) => {
          if (res) {
            this.$message({
              type: "success",
              message: "成功加入购物车",
            });
            this.$emit("addSuccess");
          }
        });
      } else {
        this.$message({
          type: "error",
          message: "组合未配置商品",
        });
      }
    },
    handleDelete(index, row) {
      console.log(row);
      this.delSetmeal(index, row);
    },
    saveEdit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.confirmSave(this.form);
        }
      });
    },
    confirmSave(item) {
      let _this = this;
      if (item.setmealId == null) {
        addSetmealRequest(item).then((res) => {
          if (res) {
            this.$message({
              type: "success",
              message: res.msg,
            });
            _this.editShow = false;
            setTimeout(() => {
              this.getList();
            }, 300);
          }
        });
      } else {
        editSetmealRequest(item).then((res) => {
          if (res) {
            this.$message({
              type: "success",
              message: res.msg,
            });
            _this.editShow = false;
            setTimeout(() => {
              this.getList();
            }, 300);
          }
        });
      }
    },
    closeEditShow() {
      this.editShow = false;
    },
    delSetmeal(index, row) {
      let _this = this;
      let nn = row.setmealName;
      _this.form.index = index;
      _this.form.setmealId = row.setmealId;
      this.$msgbox({
        title: "提示",
        message: "您确定要删除" + nn + "吗?",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        callback(res) {
          if (res == "confirm") {
            _this.delSave(_this.form);
          }
        },
      });
    },
    delSave(item) {
      let _this = this;
      let ids = [];
      ids.push(item.setmealId);
      let data = { ids: ids };
      delSetmealRequest(data).then((res) => {
        if (res) {
          this.$message({
            type: "success",
            message: res.msg,
          });
          setTimeout(() => {
            _this.getList();
          }, 300);
        }
      });
    },
    SelectionChange() {},
    getBefore() {
      // 3.5.导出之前
      let _this = this;
      this.$msgbox({
        title: "提示",
        message: "是否确认导出全部?",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        callback(res) {
          if (res == "confirm") {
            _this.get();
          }
        },
      });
    },

    get() {
      // 3.6.导出
      exportSetmealReequest({
        setmealType: this.obj.id,
      }).then((res) => {
        if (res) {
          var aLink = document.createElement("a");
          aLink.href = getUrl(res.url);
          aLink.href = getUrl(res.url.replace("组合品列表", "全部组合品列表"));
          aLink.download = "组合品.xls";
          aLink.style.display = "none";
          aLink.target = "_blank";
          document.body.appendChild(aLink);
          aLink.click();
          document.body.removeChild(aLink);
        }
      });
    },

    getBefore2() {
      // 3.5.导出之前
      let _this = this;
      const _selectData = this.$refs.tableF.selection;
      if (_selectData.length > 0) {
        this.$msgbox({
          title: "提示",
          message: "是否确认导出选中?",
          showCancelButton: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          callback(res) {
            if (res == "confirm") {
              _this.get2();
            }
          },
        });
      }
    },

    get2() {
      let searchId = "";
      const _selectData = this.$refs.tableF.selection;
      for (let i = 0; i < _selectData.length; i++) {
        if (searchId != "") {
          searchId += ",";
        }
        searchId += _selectData[i].setmealId;
      }
      if (searchId != "") {
        // 3.6.导出
        exportSetmealReequest({
          searchId: searchId,
          setmealType: this.obj.id,
        }).then((res) => {
          if (res) {
            var aLink = document.createElement("a");
            aLink.href = getUrl(res.url);
            aLink.href = getUrl(res.url.replace("组合品列表", "选中组合品列表"));
            aLink.download = "组合品.xls";
            aLink.style.display = "none";
            aLink.target = "_blank";
            document.body.appendChild(aLink);
            aLink.click();
            document.body.removeChild(aLink);
          }
        });
      }
    },
    loadShow(row) {
      console.log(row);
      if (localStorage.token) {
        this.token = localStorage.token;
        this.getList(); // 4.1.获取套餐列表信息
      }
    },
  },
  watch: {
    obj: function(val) {
      console.log(val);
      this.goodsShow = false;
      if (localStorage.token) {
        this.token = localStorage.token;
        this.getList(); // 4.1.获取套餐列表信息
      }
    },
  },

  mounted() {
    this.goodsShow = false;
    // 4.mounted
    if (localStorage.token) {
      this.token = localStorage.token;
      this.getList(); // 4.1.获取套餐列表信息
    }
  },
};
</script>
